import { render, staticRenderFns } from "./MgnlListingArticlesWithFeatured.vue?vue&type=template&id=1bb3cc52&"
import script from "./MgnlListingArticlesWithFeatured.vue?vue&type=script&lang=js&"
export * from "./MgnlListingArticlesWithFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports